import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import CardMedia from '@material-ui/core/CardMedia';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { Nav, Header } from '../../components/';
import navbackgroundImg from '../../static/images/navBackground.png';
import navbackgroundOrangeImg from '../../static/images/navBackground-orange.png';
import { LoginPop } from '../../components/Login';
import { hideLoginPopup } from '../../redux/actions';
import { useActionable } from '../../utils/hooks';
import { envP } from '../../utils/environments';

const useStyle = makeStyles((theme) => ({
  root: {
    backgroundColor: '#f1f6ff',
  },
  content: ({ sso, hideNav }) => {
    if (hideNav) {
      return {};
    }
    return {
      margin: sso ? '0' : '4.375rem 0  0 6.25rem',
      display: 'flex',
      flexDirection: 'column',
    };
  },
  fixedHeight: {
    padding: '4.375rem 0  0 6.25rem',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
}));

export default function PageIndex({ children }) {
  const fullScreen = useSelector((state) => state.fullScreenReducer);
  const env = useSelector((state) => state.envReducer);
  const location = useLocation();
  const actionable = useActionable();
  const hideNav = useMemo(() => actionable || fullScreen, [actionable, fullScreen]);
  const sso = useSelector((state) => state.ssoReducer);
  const classes = useStyle({ sso, hideNav });
  const showLogin = useSelector((state) => state.LoginPopupReducer);
  const dispatch = useDispatch();
  const wantFixedHeight = useMemo(() => ['/dutyassign'].includes(location.pathname), [location]);
  const navBackgroundImage = useMemo(() => env === envP.PPS ? navbackgroundOrangeImg : navbackgroundImg, [env]);

  return (
    <div className={classes.root}>
      {!hideNav && (
        <>
          <CardMedia image={navBackgroundImage}>
            <Nav />
          </CardMedia>
          <Header />
        </>
      )}
      <div className={wantFixedHeight ? classes.fixedHeight : classes.content}>{children}</div>
      {showLogin && (
        <LoginPop closehandle={() => dispatch(hideLoginPopup())} submitHandle={() => dispatch(hideLoginPopup())} />
      )}
    </div>
  );
}
